import './footer-style.css';
import { Link } from 'react-router-dom';
import { IoLocationSharp } from 'react-icons/io5';
import { MdEmail } from 'react-icons/md';
import { IoMdTime } from 'react-icons/io';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { useState } from 'react';
import Modal from '../../utils/Modal';

function Footer() {
    const [showModal, setShowModal] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    
    // Detect if user is on mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const handlePhoneClick = (e) => {
        if (!isMobile) {
            // On desktop, prevent default and show modal
            e.preventDefault();
            setShowModal(true);
        }
        // On mobile, allow default behavior (tel: link)
    };

    const handleEmailClick = (e) => {
        if (!isMobile) {
            // On desktop, prevent default and show modal
            e.preventDefault();
            setShowEmailModal(true);
        }
        // On mobile, allow default behavior (mailto: link)
    };

    const handleModalConfirm = () => {
        // Close the modal
        setShowModal(false);
    };

    const handleEmailModalConfirm = () => {
        // Close the modal
        setShowEmailModal(false);
    };

    return (   
        <footer className="footer">
            <div className="footer__nav">
                <Link to="/contacto">Contacto</Link>
                <Link to="/servicios">Servicio</Link>
                <Link to="/nosotros">Acerca de</Link>
            </div>
            
            <div className="footer__content">
                <a 
                    href="https://www.google.com/maps/place/9%C2%B055'00.5%22N+84%C2%B031'10.9%22W/@9.9167954,-84.5222642,860m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d9.9167954!4d-84.5196893?hl=es&entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__item footer__item--link"
                >
                    <div className="footer__icon">
                        <IoLocationSharp />
                    </div>
                    <div className="footer__text">
                        <p className="footer__section-title">Ubicación</p>
                        <p>Orotina, Alajuela</p>
                    </div>
                </a>

                <a 
                    href="mailto:gemevm@gmail.com"
                    className="footer__item footer__item--link"
                    onClick={handleEmailClick}
                >
                    <div className="footer__icon">
                        <MdEmail />
                    </div>
                    <div className="footer__text">
                        <p className="footer__section-title">Email</p>
                        <p>gemevm@gmail.com</p>
                    </div>
                </a>

                <div className="footer__item">
                    <div className="footer__icon">
                        <IoMdTime />
                    </div>
                    <div className="footer__text">
                        <p className="footer__section-title">Horario</p>
                        <div className="footer__schedule">
                            <div className="footer__schedule-column">
                                <p className="footer__schedule-day">Lunes – Viernes</p>
                                <p>8:00 am 12:00 pm</p>
                                <p>1:00 pm 5:00 pm</p>
                            </div>
                            <div className="footer__schedule-column">
                                <p className="footer__schedule-day">Sábados</p>
                                <p>8:00 am 12:00 pm</p>
                            </div>
                        </div>
                    </div>
                </div>

                <a 
                    href="tel:+50689105489"
                    className="footer__item footer__item--link"
                    onClick={handlePhoneClick}
                >
                    <div className="footer__icon">
                        <BsFillTelephoneFill />
                    </div>
                    <div className="footer__text">
                        <p className="footer__section-title">Teléfono</p>
                        <p>(+506) 8910-5489</p>
                    </div>
                </a>
            </div>

            <div className="footer__copyright">
                <p>Design with love © GemelasVillalobos 2026. All right reserved</p>
            </div>

            <Modal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title="Información de Contacto"
                confirmText="Entendido"
            >
                <p>El botón de celular solo funciona para llamar en dispositivos móviles.</p>
                <p>Si estás en PC, por favor usa tu teléfono móvil para llamar al:</p>
                <p className="modal-phone">(+506) 8910-5489</p>
            </Modal>

            <Modal
                isOpen={showEmailModal}
                onClose={() => setShowEmailModal(false)}
                onConfirm={handleEmailModalConfirm}
                title="Información de Contacto"
                confirmText="Entendido"
            >
                <p>El botón de correo solo funciona para enviar emails en dispositivos móviles.</p>
                <p>Si estás en PC, por favor copia el correo electrónico:</p>
                <p className="modal-phone">gemevm@gmail.com</p>
            </Modal>
        </footer>
    );
}

export default Footer;